import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as mtz from 'moment-timezone';
import { ScheduleService } from './schedule.service';
import { Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MultipleSchedulerComponent } from '../multiple-scheduler/multiple-scheduler.component';
import { MatDialog } from '@angular/material';
import { SubmittedFormFilterService } from '../submitted-form-filter/submitted-form-filter.service';
declare var $: any;

@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {
    i = Array;
    calenderView = 24;
    calenderHours = 24;
    date = new FormControl(moment().format());
    listedView = false;
    selectingList;
    selectedDataList;
    pageNumber: number = 0;
    // sticky: boolean = false;
    // col1;
    // colview;
    row1;
    arrayList = [];
    rowview;
    showDeletePopup = false;
    flag = 0;
    submittedFormsList;
    usersList = [];
    userMainList;
    searchText;
    submittedFormMainList;
    uid;
    uname;
    tid;
    tname;
    showView: any;
    getDate;
    getAssetNames;
    searchUsers;
    deleteSchedule;
    colors = [
        '#4363d8',
        '#469990',
        '#000075',
        '#42d4f4',
        '#911eb4',
        '#f032e6',
        '#800000',
        '#9A6324',
        '#808000',
        '#e6194B',
        '#f58231',
        '#3cb44b',
        '#bfef45'
    ];
    colorList = [];


    constructor(
        private _scheduleService: ScheduleService,
        private _router: Router,
        public dialog: MatDialog,
        private filterDeatailservice: SubmittedFormFilterService,
        ) {
        this.getDate = moment(this.date.value).format(
            'YYYY-MM-DD'
        );
    }

    ngOnInit() {
        this.initAutoScroll();
        this.findUser();
        this.gettemplateName();
        this.getAllSchedule();
    }
    showScheduleList(row, userid, index) {
        this.getFormsList(false)
        this.flag = index;
        this.uid = userid;
        this.row1 = row;
        this.showView = this.calculateTimeForDisplay(row, index);
        console.log(this.showView);
        let toFindArrayList = _.find(this.arrayList, {
            userId: userid._id,
            scheduleAt: this.showView
        });
        // console.log(row,userid._id,index,this.showDeletePopup);
        // console.log(toFindArrayList, "hello");
        if (toFindArrayList) {
            this.showDeletePopup = !this.showDeletePopup;
            this.listedView = false;
            this.deleteSchedule = toFindArrayList.scheduleId;
            // return toFindArrayList.templateName;
        } else {
            this.searchText = '';
            this.showDeletePopup = false;
            if (this.getDate >= moment(new Date()).utc().format('YYYY-MM-DD')) {
                if (!this.listedView) {
                    this.uid = userid;
                    this.rowview = row;
                }
                console.log('else');
                this.listedView = !this.listedView;
            }
        }
    }
    getFirstLetterString(name) {
        let result = '';
        let splitArray = name.split(' ');
        if (name.length === 1) {
            result = name;
        } else if (splitArray.length === 1) {
            result = splitArray[0][0] + splitArray[0][1];
        } else {
            _.forEach(splitArray, function (word) {
                result = result.concat(word[0]);
            });
        }
        return result.substring(0, 2).toUpperCase();
    }



    setColorData(row, userIds, ind) {
        this.showView = this.calculateTimeForDisplay(row, ind);
        let toFindArrayList = _.find(this.arrayList, {
            userId: userIds,
            scheduleAt: this.showView.toString()
        });
        if (toFindArrayList) {
            // return toFindArrayList.templateName;
            let MyColor = _.find(this.colorList, {
                colorId: toFindArrayList.templateId
            });
            if (MyColor) {
                return MyColor.colorName;
            }
        } else
            return '#fff';

    }
    showDataText(row, userIds, ind) {
        this.showView = this.calculateTimeForDisplay(row, ind);
        let toFindArrayList = _.find(this.arrayList, {
            userId: userIds,
            scheduleAt: this.showView.toString()
        });
        if (toFindArrayList) {
            return toFindArrayList.templateName;
        }
    }
    showDataText2(row, downuserIds, ind) {
        this.showView = this.calculateTimeForDisplay(row, ind);
        let toFindArrayList = _.find(this.arrayList, {
            userId: downuserIds,
            scheduleAt: this.showView.toString()
        });
        if (toFindArrayList) {
            return toFindArrayList.templateName;
        }
    }
    statusBased(row, userId, ind) {
        this.showView = this.calculateTimeForDisplay(row, ind);
        let toFindArrayList = _.find(this.arrayList, {
            userId: userId,
            scheduleAt: this.showView.toString()
        });
        if (toFindArrayList) {
            return toFindArrayList.status;
        }
    }
    navigateInspectionPreview(row, userId, ind) {
        this.showView = this.calculateTimeForDisplay(row, ind);
        let toFindArrayList = _.find(this.arrayList, {
            userId: userId,
            scheduleAt: this.showView.toString()
        });
        if (toFindArrayList) {
            let getStatus;
            getStatus = toFindArrayList.status;
            if (getStatus !== 0) {
                this._router.navigateByUrl('/submittedFormPreview/' + toFindArrayList.scheduleId);
            } else {
                return
            }
        }
    }

    setTick(tick) {
        this.selectingList = tick;
    }
    calculateTimeForDisplay(row, flag) {
        let time = '';
        if (row === 0) {
            time = this.getDate + 'T00' + ':';
        } else {
            if (row.toString().length === 1) {
                time = this.getDate + 'T0' + row + ':';
            } else {
                time = this.getDate + 'T' + row + ':';
            }
        }
        if (flag === 1)
            return time + '00:00Z';
        else
            return time + '30:00Z';
    }

    calculateTime(row) {
        let time = '';
        if (row === 0) {
            time = this.getDate + 'T00' + ':';
        } else {
            if (row.toString().length === 1) {
                time = this.getDate + 'T0' + row + ':';
            } else {
                time = this.getDate + 'T' + row + ':';
            }
        }
        if (this.flag === 1)
            time = time + '00:00';
        else
            time = time + '30:00';

        return time;
    }
    getNewUsers(value) {
        this.usersList = this.userMainList.filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        this.showDeletePopup = false;
        this.listedView = false;
    }
    getFormsList(value) {
        if (value !== false) {
            this.submittedFormsList = this.submittedFormMainList.filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        } else {
            this.submittedFormsList = this.submittedFormMainList;
        }
    }


    getColor(formName) {
        // console.log(this.colorList, "color");
        // console.log(formName, "form name");
        let MyColor = _.find(this.colorList, {
            colorId: formName
        });
        // console.log(MyColor);
        return MyColor.colorName;
    }

    selectdList() {
        let templateListId: any;
        this.selectedDataList = this.selectingList;
        let time = this.calculateTime(this.row1);
        templateListId = _.find(this.submittedFormsList, {
            name: this.selectedDataList
        });
        let teamTimezone = localStorage.getItem("timezone");
        let scheduleObj = {
            userId: this.uid._id,
            userName: this.uid.name,
            userRole: this.uid.role,
            templateId: templateListId._id,
            templateName: this.selectedDataList,
            scheduleAt: time + moment().format('Z'),
            status: 0
        };
        if(!_.isEmpty(teamTimezone)) {
            let selectedMoment = mtz.tz(this.date.value, "YYYY-MM-DD",teamTimezone);
            selectedMoment.set({ hour: this.row1, minute: (this.flag == 1 ? 0 : 30) });
            scheduleObj.scheduleAt = selectedMoment.format();
        }
        // this.arrayList.push(scheduleObj);
        this.selectingList = {};
        this.listedView = !this.listedView;
        // console.log(this.arrayList, 'dsvfdvfdvfd');
        this._scheduleService.createSchedule(scheduleObj).subscribe(
            (res: any) => {
                console.log(res, 'response');
                let scheduleObj = {
                    userId: this.uid._id,
                    userName: this.uid.name,
                    templateId: templateListId._id,
                    templateName: this.selectedDataList,
                    scheduleAt: time + 'Z',
                    scheduleId: res.data[0].id,
                    status: 0
                };
                this.arrayList.push(scheduleObj);
            }
        );
    }
    settime(row, index) {
        let time = '';
        if (row === 0) {
            time = '00' + ':';
        } else {
            time = row + ':';
        }
        if (index === 1)
            return time + '00';
        else
            return time + '30';
    }
    deleteInspection(row, usersid, index) {
        this.showView = this.calculateTimeForDisplay(row, index);
        let time = this.showView;
        let toFindArrayList = _.find(this.arrayList, {
            userId: usersid,
            scheduleAt: this.showView
        });
        let scheduleId = toFindArrayList.scheduleId;
        console.log(toFindArrayList);
        this.showDeletePopup = !this.showDeletePopup;
        this._scheduleService.deleteSchedule(scheduleId).subscribe(
            (res: any) => {
                // console.log(this.arrayList.length);
                let result = this.arrayList.findIndex(function (object) {
                    return object.userId === usersid && object.scheduleAt === time;
                });
                // console.log(result);
                // console.log(this.arrayList[result])
                // delete(this.arrayList[result]);
                this.arrayList.splice(result, 1);
                this.setColorData(row, usersid, index);
                // console.log(this.arrayList.length);
            }
        );
    }
    getAllSchedule() {
        this._scheduleService.getAllSchedule().subscribe(
            (res: any) => {
                this.getAssetNames = res.data;
                let teamTimezone = localStorage.getItem("timezone");
                _.forEach(this.getAssetNames, (key) => {
                    if (key.assignedTo && key.assignedTo._id) {
                        let scheduleObj = {
                            userId: key.assignedTo._id,
                            userName: key.assignedTo.name,
                            templateId: key.template._id,
                            templateName: key.template.name,
                            scheduleAt: moment.utc(key.scheduleAt).local().format("YYYY-MM-DDTHH:mm:ss") + 'Z',
                            scheduleId: key._id,
                            status: key.status
                        };

                        if(!_.isEmpty(teamTimezone)) {
                            let localDate = mtz(key.scheduleAt).tz(teamTimezone).format("YYYY-MM-DDTHH:mm:ss") + 'Z'
                            scheduleObj.scheduleAt = localDate;
                        }
                        this.arrayList.push(scheduleObj);
                    }
                });
            }
        );
    }
    // resetSearch() {
    //   this.searchText = '';
    // }
    gettemplateName() {
        this._scheduleService
            .gettingInspectionTemplate(this.pageNumber)
            .subscribe((result: any) => {
                this.submittedFormMainList = result.data;
                this.submittedFormsList = this.submittedFormMainList;
                // this.generateColors();
                for (let form of this.submittedFormsList) {
                    let getRandomLength = Math.floor((Math.random() * this.colors.length) + 0);
                    // let getRandomLength = Math.random() * (this.colors.length - 0) + 0;
                    let colorObj = {
                        colorId: form._id,
                        colorName: this.colors[getRandomLength],
                    };
                    // console.log(colorObj, "p object");
                    this.colorList.push(colorObj);
                }
                // console.log(this.colorList);
                // this.submittedFormMainList ;
                // let basedOnLength = Object.keys(this.submittedFormsList).length;
                console.log(this.submittedFormsList);
                // console.log(basedOnLength);
                _.forEach(this.submittedFormsList, user => {
                    // console.log(user.name);
                });
                this.pageNumber++;
            });
    }

    findUser() {
        this._scheduleService
            .gettingUsers(this.pageNumber)
            .subscribe((result: any) => {
                this.userMainList = result.data;
                console.log(this.usersList);
                _.forEach(this.userMainList, user => {
                    // console.log(user.name);
                });
                _.forEach(this.userMainList, (user) => {
                    _.forEach(user.teams, (team) => {
                        const userTeamId = team.teamDetails._id;
                        if (userTeamId === localStorage.getItem('teamId')) {
                            user.userStatus = team.userStatus;
                        }
                    });
                });

                this.userMainList = _.filter(this.userMainList, (user) => {
                    return user.userStatus === true && !user.verificationCode
                })

                this.userMainList = _.orderBy(this.userMainList, [user => user.name.toLowerCase()], ['asc']);
                this.usersList = this.userMainList;
            });

    }

    getRandomColor() {
        return '#' + Math.floor(Math.random() * 0xffffff).toString(16);
    }

    initAutoScroll() {
        let headerTarget = $('#timelineblock');
        let source = $('#renderarea');
        let verticalTarget = $('#locationarea');
        source.scroll(function () {
            headerTarget
                .prop('scrollTop', this.scrollTop)
                .prop('scrollBottom', this.scrollBottom);
            verticalTarget
                .prop('scrollTop', this.scrollTop)
                .prop('scrollBottom', this.scrollBottom);
        });
        headerTarget.scroll(function () {
            source
                .prop('scrollTop', this.scrollTop)
                .prop('scrollBottom', this.scrollBottom);
        });
    }
    addEvent(event: MatDatepickerInputEvent<Date>) {
        if (this.arrayList && event.target.value) {
            this.getDate = moment(event.target.value).format(
                'YYYY-MM-DD'
            );
            this.listedView = false;
        }
    }

    openMultipleScheduler(): void {


        let dialoRef = this.dialog.open(MultipleSchedulerComponent, {
            width: '600px',
            height: '500px',
            data: {
                templates: this.submittedFormMainList,
                users: this.userMainList
            }
        });

        dialoRef.afterClosed().subscribe((result) => {
            if(result && result['continueClose']) {
                this.getAllSchedule();
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/schedule/schedule.component.ts